/**
 * Copyright © 2026 Adnuntius AS.
 */
import {Component, Inject} from '@angular/core';
import template from './context-service-configuration-list-page.component.html';
import {AdminListColumn, AdminResourceListPageBase} from '../../common/controller/admin-resource-list-page-base';
import {LocalNetworkProfile} from '../../../components/session/local-network-profile';

@Component({
  standalone: false,
  selector: 'adn-context-service-configuration-list-page',
  template
})
export class ContextServiceConfigurationListPageComponent extends AdminResourceListPageBase {
  readonly itemStateName = 'app.adm.context-service-configurations.context-service-configuration';

  readonly columns: AdminListColumn[] = [
    {param: 'name'},
    {param: 'description'},
    {param: 'contextService'},
    {param: 'username'},
    {param: 'apiKey'}
  ];

  constructor(@Inject(LocalNetworkProfile) LocalNetworkProfile: any) {
    super(LocalNetworkProfile);
  }
}
